module.exports = __webpack_public_path__ + "img/shopping-ctaBtn.6c2d1b5e.svg";